export function tagIndexRequest() {
  return {
    type: '@tags/INDEX_REQUEST',
  };
}

export function tagIndexSuccess(data) {
  return {
    type: '@tags/INDEX_SUCCESS',
    payload: { data },
  };
}

export function tagIndexFailure() {
  return {
    type: '@tags/INDEX_FAILURE',
  };
}

export function tagCreateRequest(data, onCreated) {
  return {
    type: '@tags/CREATE_REQUEST',
    payload: { data, onCreated },
  };
}

export function tagCreateSuccess() {
  return {
    type: '@tags/CREATE_SUCCESS',
  };
}

export function tagCreateFailure() {
  return {
    type: '@tags/CREATE_FAILURE',
  };
}
